import styled from 'styled-components';

const DisclaimerDiv = styled.div`
    font-size: 12px; text-align: center; margin-top: 8px;
    @media (max-width: 768px) {
        text-align: left;
    }
`

export const Disclaimer:React.FC = () => {
    return (
        <DisclaimerDiv>
            Alle Angaben ohne Gewähr. Bitte überpüfen Sie alle Informationen auf der Website des Kantons St.Gallen <a target="_blank" rel="noreferrer" title="Webseite des Kantons St.Gallen" href="https://www.sg.ch">www.sg.ch</a>
        </DisclaimerDiv>
    )
}